import { DeviceService } from '@/services/device.service';

export const deviceService = new DeviceService(
  window.navigator.userAgent,
  window.screen,
  window.devicePixelRatio || 1,
);
